import { render, staticRenderFns } from "./shared-carousel.vue?vue&type=template&id=1f527701&scoped=true"
import script from "./shared-carousel.vue?vue&type=script&lang=js"
export * from "./shared-carousel.vue?vue&type=script&lang=js"
import style0 from "./shared-carousel.vue?vue&type=style&index=0&id=1f527701&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f527701",
  null
  
)

export default component.exports